import ProgressHUD from './../../ProgressHUD/index.vue'
import { Api, Toast } from './../../../services'

export default {
  name: 'GreenFundDetails',
  props: {
    project: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  mounted() {
    console.log("******************")
    console.log(this.project.videoURL)    
    // document.getElementById("video").insertAdjacentHTML('afterbegin', this.project.videoURL);
    // $(".details-cmb-img iframe").css("width", '100%')
    // $(".details-cmb-img iframe").css("height", '450px')
  },
  // watch: {
  //   $route() {
  //     this.search.text = this.$route.query.text || ''
  //     this.search.type = this.$route.query.type || 'all'
  //     this.search.numberPage = +this.$route.query.page || 1

  //     this.refreshDisplayProjects()
  //   },
  // },
  methods: {
    changeTypeFilter(type) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          type: type,
        }),
      })
    },
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    
    async refreshDisplayProjects() {
      // try {
      //   // this.$refs.progress.show()

      //   var response = await Api.getFundProjects(this.search)
      //   this.projects = response.data.results
      //   this.search.countPages = response.data.pagination.countPages
      // } catch (error) {
      //   console.error(error)
      //   alert(error.message)
      // } finally {
      //   // this.$refs.progress.hide()
      // }
    },   
  },
  async created() {
     try {
      console.log("response>>>>>>>>>>>>>>>>>>>>>> FUND DETAILS ")
      
      // await this.getFundProjectById(this.$route.params.id)
      var response = await Api.getFundProjectById(this.$route.params.id) 
      console.log(response)
      // this.setData(response.data.results[0])
      // await this.getCountForProjectsById()
    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
    
    // this.search.text = this.$route.query.text || ''
    // this.search.type = this.$route.query.type || 'all'
    // this.search.numberPage = +this.$route.query.page || 1
   
    // this.$nextTick().then(() => this.refreshDisplayProjects())
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/GreenFundDetails/GreenFundDetails.component.js